import { Phone, Navigation, UtensilsCrossed } from "lucide-react";
import { Link } from "react-router-dom";
import { BUSINESS } from "@/data/site";

// Quick action trio: Call / Directions / Menu.
export default function QuickActions({ tone = "dark", className = "" }) {
  const light = tone === "light";
  const actions = [
    { label: "Call us", sub: BUSINESS.phoneDisplay, icon: Phone, href: `tel:${BUSINESS.phoneHref}`, testid: "qa-call" },
    { label: "Directions", sub: "Sector xxx, Gurugram", icon: Navigation, href: BUSINESS.directionsUrl, external: true, testid: "qa-directions" },
    { label: "View menu", sub: "Dim sum, noodles & wok", icon: UtensilsCrossed, to: "/menu", testid: "qa-menu" },
  ];

  const base = `group flex items-center gap-4 border p-5 transition-colors duration-300 ${
    light
      ? "border-white/20 hover:border-white bg-white/5 hover:bg-white/10 text-white"
      : "border-brand-ink/12 hover:border-brand-red bg-white text-brand-ink"
  }`;

  return (
    <div className={`grid gap-3 sm:grid-cols-3 ${className}`} data-testid="quick-actions">
      {actions.map((a) => {
        const Icon = a.icon;
        const content = (
          <>
            <span
              className={`inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full transition-colors ${
                light ? "bg-white/10 text-brand-gold" : "bg-brand-red/10 text-brand-red group-hover:bg-brand-red group-hover:text-white"
              }`}
            >
              <Icon size={18} />
            </span>
            <span className="min-w-0">
              <span className="block text-sm font-semibold">{a.label}</span>
              <span className={`block text-xs truncate ${light ? "text-white/60" : "text-muted-foreground"}`}>
                {a.sub}
              </span>
            </span>
          </>
        );
        if (a.to)
          return <Link key={a.label} to={a.to} className={base} data-testid={a.testid}>{content}</Link>;
        return (
          <a
            key={a.label}
            href={a.href}
            className={base}
            data-testid={a.testid}
            {...(a.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
          >
            {content}
          </a>
        );
      })}
    </div>
  );
}
